/**
 * Orders API
 * Orders API
 *
 * The version of the OpenAPI document: 2.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';
import History from './History';
import ReferenceHistoryAllOf from './ReferenceHistoryAllOf';


class ReferenceHistory {
    
    constructor(type, timestamp, action, referenceType, referenceId, referenceTitle) { 
        History.initialize(this, type, timestamp);ReferenceHistoryAllOf.initialize(this, action, referenceType, referenceId, referenceTitle);
        ReferenceHistory.initialize(this, type, timestamp, action, referenceType, referenceId, referenceTitle);
    }

    
    static initialize(obj, type, timestamp, action, referenceType, referenceId, referenceTitle) { 
        obj['action'] = action;
        obj['referenceType'] = referenceType;
        obj['referenceId'] = referenceId;
        obj['referenceTitle'] = referenceTitle;
    }

    
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new ReferenceHistory();
            History.constructFromObject(data, obj);
            History.constructFromObject(data, obj);
            ReferenceHistoryAllOf.constructFromObject(data, obj);

            if (data.hasOwnProperty('action')) {
                obj['action'] = ApiClient.convertToType(data['action'], 'String');
            }
            if (data.hasOwnProperty('referenceType')) {
                obj['referenceType'] = ApiClient.convertToType(data['referenceType'], 'String');
            }
            if (data.hasOwnProperty('referenceId')) {
                obj['referenceId'] = ApiClient.convertToType(data['referenceId'], 'String');
            }
            if (data.hasOwnProperty('referenceTitle')) {
                obj['referenceTitle'] = ApiClient.convertToType(data['referenceTitle'], 'String');
            }
        }
        return obj;
    }


}


ReferenceHistory.prototype['action'] = undefined;


ReferenceHistory.prototype['referenceType'] = undefined;


ReferenceHistory.prototype['referenceId'] = undefined;


ReferenceHistory.prototype['referenceTitle'] = undefined;


// Implement History interface:

History.prototype['type'] = undefined;

History.prototype['timestamp'] = undefined;
// Implement ReferenceHistoryAllOf interface:

ReferenceHistoryAllOf.prototype['action'] = undefined;

ReferenceHistoryAllOf.prototype['referenceType'] = undefined;

ReferenceHistoryAllOf.prototype['referenceId'] = undefined;

ReferenceHistoryAllOf.prototype['referenceTitle'] = undefined;




ReferenceHistory['ActionEnum'] = {

    
    "add": "add",

    
    "remove": "remove"
};



ReferenceHistory['ReferenceTypeEnum'] = {

    
    "order": "order",

    
    "reverseOrder": "reverseOrder",

    
    "parentOrder": "parentOrder",

    
    "childOrder": "childOrder",

    
    "device": "device"
};



export default ReferenceHistory;

